<template>
	<!-- #747474 -->
	<div style="height: calc(100vh);overflow-y: auto;background-color: #747474">
		<!-- <el-aside :width="isCollapse?'64px':'200px'" >
			  <div class="toggle-button" @click="toggleCollapse">|||</div> -->
		<el-menu :unique-opened="true" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose"
			background-color="#747474" text-color="#fff" active-text-color="#ff0" :collapse="isCollapse">
			<div v-show="!isCollapse"
				style="display:flex;align-items:center;color:white;height: 50px;font-size: 18px;cursor: pointer;"
				@click="toHome">
				<i class="el-icon-s-home" style="margin-left:12%;color:  #ffffff;;"></i>
				<span style="margin-left:3%;color: #ffffff; ;">首页</span>
			</div>
			<el-submenu :index="index.toString()" v-for="(item,index) in sidebar" :key="index">
				<template slot="title">
					<i :class="item.icon" style="color: #ffffff;"></i>
					<span>{{item.fname}}</span>
				</template>
				<el-menu-item-group v-for="(items,indexs) in item.manageFunctionList" :key="indexs" v-if="items.isShow">
					<el-menu-item style="display:flex;align-items:center;" :index="indexs.toString()+index"
						@click="next(items)">
						{{items.fname}}</el-menu-item>
				</el-menu-item-group>
			</el-submenu>
		</el-menu>
		<!-- </el-aside> -->
		<!-- <el-row style="height:100vh;width:100%;">
            <el-col :span="12" style="height:100%;width:100%">
                
            </el-col>
        </el-row> -->
	</div>
</template>

<script>
	export default {
		name: "app",
		props: {
			'menuComponents': {
				type: Array
			},
			isCollapse: {
				type: Boolean,
				default: ""
			}
		},
		data() {
			return {
				sidebar: [{}],
				tablist: [{}]
			}
		},
		methods: {
			toggleCollapse() {
				this.isCollapse = !this.isCollapse
			},
			handleOpen(key, keyPath) {
				// console.log(key, keyPath);
			},
			handleClose(key, keyPath) {
				// console.log(key, keyPath);
			},
			next(item) {
				// if (this.$route.path != routePath) {
				//     this.$router.push(routePath)
				// }
				if (this.$route.path != item.routePath) {
					this.$router.push(item.routePath)

				}
				if (JSON.stringify(this.$store.state.openTab).includes(item.routePath)) {
					this.$store.commit('setactiveindex', item.routePath)
				} else {
					this.$store.commit('addtabs', item)
					this.$store.commit('setactiveindex', item.routePath)
					this.tablist = this.$store.state.openTab
					// console.log(this.tablist)
				}


	},
	toHome() {
		this.$router.push('/home')
	}
	},
	created() {
		let vm = this
		if (this.$route.path === '/') { //是登录直接出去
			return;
		}
		this.$api.findByManageUserIdManageFunction().then((res) => {
			if (res.state == 'success') {
				vm.sidebar = res.data
				// console.log('菜单--', res.data)
				// vm.sidebar.forEach(item => {
				//     item.manageFunctionList.forEach(i => {
				//         if (i.routePath === vm.$route.path) {
				//             vm.defaultActive = JSON.stringify(i.id)
				//         }
				//     });
				// });
			}
		})
	}
	}
</script>
<style scoped lang="less">
	html,
	body,
	#app {
		margin: 0px;
		padding: 0px;
		height: 100%;
	}


	.el-menu {
		border: none !important;
		background: transparent;
		border-right: none !important;
	}

	/deep/.el-menu--inline {
		text-align: center !important;
		border-right: none !important;
		// background: rgba(241, 248, 255, 1);
	}
</style>